import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";

const CURRENCY = getCurrency();

export const getFinancialReport = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/financial`,
    { ...params, page },
    true,
    false
  );

export const getFinancialDetailReport = ({ params, page, type }) =>
  request(
    "get",
    `/${CURRENCY}/agent/financial/detail/${type}`,
    { ...params, page },
    true,
    false
  );
